<template>
	<div>
		<card style="margin-bottom: 20px;">
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">客户搜索</span>
					<Input placeholder="搜索客户姓名/电话" v-model="name"></Input>

				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">客户经理</span>
					<Input placeholder="搜索客户经理" v-model="username"></Input>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">部门</span>
					<Select v-model="department" placeholder="部门">
						<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">进度</span>
					<Select v-model="status" placeholder="进度">
						<Option v-for="item in signStatus" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">城市</span>
					<Input placeholder="城市" v-model="city"></Input>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" v-if="this.userInfo.media_is_open == true">
				<div class="input-group">
					<span class="input-group-addon">媒体代码</span>
					<Select v-model="mediumCodeId" placeholder="媒体代码">
						<Option v-for="item in mediumCodeList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" v-if="this.userInfo.media_is_open == true">
				<div class="input-group">
					<span class="input-group-addon">媒体渠道</span>
					<Select v-model="mediumId" placeholder="媒体渠道">
						<Option v-for="item in mediumList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon chaxun">时间类型</span>
					<Select v-model="timeType" placeholder="时间类型选择">
						<Option v-for="item in timeTypeList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }">
				<div class="input-group">
					<span class="input-group-addon">时间</span>
					<DatePicker type="daterange" :value="time" placeholder="" @on-change="TimeChange">
					</DatePicker>
					</Cascader>
				</div>
				</Col>
				<Col :xs="{ span: 12}" :md="{ span:6, offset: 1 }" :lg="{ span: 4, offset: 1 }" v-if="this.userInfo.media_is_open == true">
				<div class="input-group">
					<span class="input-group-addon">是否拓客</span>
					<Select v-model="is_introduce" placeholder="是否拓客">
						<Option value=1>是</Option>
						<Option value=0>否</Option>
					</Select>
				</div>
				</Col>
				<div class="col-md-2 search-cli">
					<Button type="primary" @click="search">搜索</Button>
				</div>
			</Row>
			<Row style="padding-top: 20px;">
				<Col style="float: left;">
				<Button @click="initSearch" type="primary" style="margin-left: 20px;">重置刷新</Button>
				</Col>
			</Row>
		</card>
		<div class="multiple" style="width: 100%">
			<Table stripe border :columns="columnsContract" :data="datas" size="small" ref="table">
				<template slot-scope="{ row }" slot="operation">
					<div
						style="display: flex; flex-direction: column; align-items: center;justify-content: space-around; height: 100px;">
						<!--span :data-contract_id="row.id" @click.stop="contractManage">查看签约</span-->
						<span style="color: #2A8BF6; cursor: pointer;" :data-contract_id="row.id"
							:data-client_id="row.client_id" @click.stop="addLoan">编辑</span>
						<span style="color: #2A8BF6; cursor: pointer;" :data-contract_id="row.id"
							:data-client_id="row.client_id" @click.stop="delLoan">作废</span>
					</div>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<div style="margin-top: 5px;">
						<Button type="info" size="small" :data-contract_id="row.id" :data-loan_id="row.id"
							:data-client_id="row.client_id" style="margin-right: 5px" @click="loanManage">编辑</Button>
					</div>
				</template>			
			</Table>
		</div>
		<div class="pager1">
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<!-- 查看签约管理 -->
		<Modal v-model="modal" width="900">
			<ContractDetail :contractId="contractId"></ContractDetail>
			<div slot="footer">
				<!--Button type="default" @click="modal = false">取消</Button-->
				<Button type="primary" @click="$refs['EditContract'].save()">确定</Button>
			</div>
		</Modal>
		<!-- 编辑签约管理 -->
		<Modal v-model="editContractMadal" width="900" >
			<EditContract ref="EditContract" @reloadData="getList" :contractId="contractId"></EditContract>
			<div slot="footer">
				<Button type="primary" @click="$refs['EditContract'].save()">确定</Button>
			</div>
		</Modal>
		<!-- 进件管理 -->
		<Modal v-model="loanModal" width="900">
			<Loan ref="loan" @reloadData="getList" :loanId="loanId" :contractId="contractId" :clientId="clientId"
				:userList="userList"></Loan>
			<div slot="footer">
				<Button type="primary" @click="$refs['loan'].save()">提交</Button>
			</div>
		</Modal>
		<Modal v-model="addContractShow" width="900">
			<AddContract ref="addContract" @reloadData="getList"></AddContract>
			<div slot="footer">
			</div>
		</Modal>
	</div>
</template>
<script>
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getList,
		getCount,
		addPool,
		giveOut,
		getClientLoan,
		getSignList,
		getLoanList,
		getHelpLoanList,
		delContract,
		delLoan
	} from '@/api/client'
	import {
		passContract,
		refuseContract,
		passRepayment,
		refuseRepayment,
	} from '@/api/finance'
	import {
		getUserList,
		getMyClientTips,
		getAnnounce,
		getDepartmentList,
	} from '@/api/user'	
	import {
		getAllMediumCode,
		getAllMedium,
	} from "../../api/runSet";
	import AddContract from '../task/AddContract.vue';
	import EditContract from "../task/EditContract";
	import ContractDetail from "../task/ContractDetail.vue";
	import EditClue from './EditClue.vue';
	import Loan from "../task/Loan";
	export default {
		name: "LoanList",
		components: {
			AddContract,
			EditContract,
			Loan,
			EditClue,
			ContractDetail
		},
		data() {
			return {
				editModalStyle: {
					'top': '7%',
					'background': '#f9fafc',
					'border-radius': '15px'
				},
				editDiv: false,
				editModal: false,
				editClientId: 0,
				city:'',
				pageSize: 10,
				pageSizeOpts: [20, 50, 100, 500],
				loanList: [],
				checkModal: false,
				giveOutUid: 0,
				giveOutModal: false,
				clientId: 0,
				loanId: 0,
				loanModal: false,
				contractId: 0,
				timeTypeList: [{
						value: 1,
						label: '客户申请时间'
					},
					{
						value: 2,
						label: '签约时间'
					},
					{
						value: 3,
						label: '进件时间'
					},
					{
						value: 4,
						label: '回款时间'
					}
				],
				signStatus: [{
						value: 1,
						label: '审核中'
					},
					{
						value: 2,
						label: '已批款'
					},
					{
						value: 3,
						label: '银行已拒绝'
					},
					{
						value: 4,
						label: '已回款'
					},
					{
						value: 5,
						label: '违约'
					}
				],
				modal: false,
				editContractMadal: false,
				count: 0,
				page: 1,
				name: '',
				username:'',
				timeType: 2,
				timeDimension: 0,
				timePeriod: 0,
				sign_time: '', //申请时间
				apply_time: '',
				userList: [],
				is_add_wechat: [],
				timePeriodDate: [],
				oldDatas: [],
				datas: [],
				columnsContract: [{
						type: 'selection',
						width: 60,
						align: 'center'
					},
					{
					    title: 'Action',
					    slot: 'action',
					    width: 300,
					    align: 'center'
					},
					{
						"title": "在审件id",
						"key": "id",
						"width": 100,
					},
					{
						"title": "进件日期",
						"key": "created_at",
						"width": 100,
					},
					{
						"title": "贷款顾问",
						"key": "sign_name",
						"width": 100,
					},
					{
						"title": "协助人",
						"key": "help_name",
						"width": 100,
					},
					{
						"title": "部门",
						"key": "department_name",
						"width": 100,
					},
					{
						"title": "客户姓名",
						"key": "name",
						"width": 100
					},
					{
						"title": "客户申请时间",
						"key": "apply_time",
						"width": 100,
					},
					{
						"title": "进件产品",
						"key": "product_name",
						"width": 100,
					},
					{
						"title": "费率",
						"key": "rate",
						"width": 100,
					},
					{
						"title": "进件额度",
						"key": "loans_money",
						"width": 80
					},
					{
						"title": "进度",
						"key": "status",
						"width": 100,
					},
					{
						"title": "批款额度",
						"key": "get_money",
						"width": 80
					},
					{
						"title": "收款日期",
						"key": "repay_at",
						"width": 100,
					},
					{
						"title": "回款金额",
						"key": "repay_money",
						"width": 80
					},
					{
						"title": "后勤费",
						"key": "channel_fee",
						"width": 80
					},
					{
						"title": "媒体代码",
						"key": "media_name",
						"width": 80
					},
					{
						"title": "合同审核",
						"key": "check_status",
						"width": 100
					},
					{
						"title": "回款审核",
						"key": "pay_check_status",
						"width": 100,
					},
				],
				departmentList:[],
				department:'',
				status:'',
				mediumId:'',
				mediumCodeId:'',
				mediumCodeList:[],
				mediumList:[],
				time:'',
				addContractShow:false,
				is_introduce:'',
			}
		},
		computed: {

			...mapGetters(['token','userInfo']),
		},
		mounted: function() {
			this.loadData();
			this.getList();
			this.getCount();
		},
		watch: {
			$route() {
				this.loadData();
				this.getList();
			},
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			addLoanContract() {
				this.addContractShow = true;
			},

			mySearchByMoney(loanMoney) {
				this.loanMoney = loanMoney[0];
				this.page = 1;
				this.getList();
			},
			mySearchByStart(start) {
				this.start = start;
				this.page = 1;
				this.getList();
			},
			search() {
				this.page = 1;
				this.getList();
			},
			edit(e) {
				let that = this;
				let id = e.id;
				this.editClientId = id;
				this.editDiv = true;
				this.$nextTick(function() {
					that.oldDatas = that.datas;
					that.editModal = true;
				})
			},
			TimeChange(e) {
				this.time = e;
			},
			async loadData() {
				let that = this;
				that.initSearch();
				var data = {
					token: this.token
				};
				let res = await getAllMediumCode(that, data);
				if (res.code == 1) {
					that.mediumCodeList = res.data.list;
				}
				res = await getAllMedium(that, data);
				if (res.code == 1) {
					that.mediumList = res.data.list;
				}
				var data = {
					token: that.token
				};
				res = await getUserList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async getCount() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getCount(that, data);
				if (res.code == 1) {
					that.$Message.success('获取成功');
					that.countData = res.data;
				}
			},
			initSearch() {
				this.name = '';
				this.timeDimension = 0
				this.timePeriod = 0;
				this.status = '';
				this.timePeriodDate = [];
				this.username = '';
				this.department = '';
				this.status = '',
				this.city = '',
				this.mediumId = '';
				this.mediumCodeId = '';
				this.time = '';
				this.is_introduce = '';
				this.getList();
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.limit = this.pageSize;
				data.token = this.token;
				data.page = this.page;
				that.throttle(async function() {
					let res = await getHelpLoanList(that, data);
					that.datas = res.data.list;
					that.count = res.count;
					this.addContractShow = false;
					this.loanModal =false;
				}, 200)
			},
			passContract(e) {
			    let that = this;
			    let id = e.currentTarget.dataset.contract_id;
			    this.$Modal.confirm({
			        title: '确认通过合同审核吗？',
			        onOk: async () => {
			            let res = await passContract(that, {token: that.token, id: id});
			            if (res.code == 1) {
			                that.$Message.success(res.msg);
			                that.getList();
			            }
			        }
			    })
			},
			refuseContract(e) {
			    let that = this;
			    let id = e.currentTarget.dataset.contract_id;
			    this.$Modal.confirm({
			        title: '确认拒绝合同审核吗？',
			        onOk: async () => {
			            let res = await refuseContract(that, {token: that.token, id: id});
			            if (res.code == 1) {
			                that.$Message.success(res.msg);
			                that.getList();
			            }
			        }
			    })
			},
			passRepayment(e) {
			    let that = this;
			    let id = e.currentTarget.dataset.contract_id;
			    this.$Modal.confirm({
			        title: '确认通过回款审核吗？',
			        onOk: async () => {
			            let res = await passRepayment(that, {token: that.token, id: id});
			            if (res.code == 1) {
			                that.$Message.success(res.msg);
			                that.getList();
			            }
			        }
			    })
			},
			refuseRepayment(e) {
			    let that = this;
			    let id = e.currentTarget.dataset.contract_id;
			    this.$Modal.confirm({
			        title: '确认拒绝回款审核吗？',
			        onOk: async () => {
			            let res = await refuseRepayment(that, {token: that.token, id: id});
			            if (res.code == 1) {
			                that.$Message.success(res.msg);
			                that.getList();
			            }
			        }
			    })
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			contractManage(e) {
				let that = this;
				that.contractId = e.currentTarget.dataset.contract_id;
				that.modal = true;
			},
			editContract(e) {
				let that = this;
				that.contractId = e.currentTarget.dataset.contract_id;
				that.editContractMadal = true;
			},
			async loanManage(e) {
				let that = this;
				// let data = {token: that.token, client_id: e.currentTarget.dataset.client_id};
				that.contractId = e.currentTarget.dataset.contract_id;
				that.clientId = e.currentTarget.dataset.client_id;
				that.loanId = e.currentTarget.dataset.loan_id;
				that.$refs['loan'].loadData();
				that.loanModal = true;
			},
			async addLoan(e) {
				let that = this
				that.contractId = e.currentTarget.dataset.contract_id;
					this.$router.push({
						name: 'addLoan',
						query: {
							contractId: that.contractId,
						},
					})
			},
			async delLoan(e) {
				let that = this;
				let loan_id = e.currentTarget.dataset.contract_id;
				this.$Modal.confirm({
					title: '确认要作废该进件吗？',
					onOk: async () => {
						let res = await delLoan(that, {
							token: that.token,
							loan_id: loan_id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			async delContract(e) {
				let that = this;
				let contract_id = e.currentTarget.dataset.contract_id;
				this.$Modal.confirm({
					title: '确认要作废该签约合同吗？',
					onOk: async () => {
						let res = await delContract(that, {
							token: that.token,
							contract_id: contract_id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			checkLoan(e) {
				let that = this;
				that.$refs['loan'].loadData();
				that.loanModal = true;
			},
			timestampToTime(timestamp) {
				var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				var D = (date.getDate() + 1 < 10 ? '0' + (date.getDate() + 1) : date.getDate() + 1) + ' ';
				var h = (date.getHours() + 1 < 10 ? '0' + (date.getHours() + 1) : date.getHours() + 1) + ':';
				var m = (date.getMinutes() + 1 < 10 ? '0' + (date.getMinutes() + 1) : date.getMinutes() + 1);
				return Y + M + D + h + m;
			}
		}
	}
</script>
<style scoped lang="less">
	.hong {
		color: #F56171;
		font-weight: bold;
		cursor: pointer;
	}

	.pager {
		padding-left: 0;
	}

	.lan {
		color: #124386;
		font-weight: bold;
		cursor: pointer;
	}

	.sousuo {
		width: 100%;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-modal-content {
		background-color: #f9fafc;
	}

	/deep/ .ivu-table-header thead tr th {
		text-align: center !important;
	}

	/deep/ .ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.count_tips {
		color: rgb(0, 0, 0);
		justify-content: center !important;
		background: rgb(229, 245, 253);
		width: 1400px;
		margin: 0 auto;
		/* padding: 5px; */
		line-height: 35px;
		height: 35px;
	}

	.count_tips_img {
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-right: 5px;
		margin-bottom: 3px;
	}

	.announce_div {
		position: relative;
		background-color: #F2F2F2;
		color: #E8410B;
		margin-bottom: 20px;
	}

	.announce_img {
		position: absolute;
		left: 4px;

		img {
			width: 20px;
			height: 20px;
			margin-top: 5px;
		}
	}

	.announce_area {
		margin-left: 25px;
		overflow: hidden;

		marquee {
			margin-top: 5px;
		}
	}

	/deep/ .ivu-table table {
		width: 100% !important;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #FF6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
